import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core/";
import { useSelector } from "react-redux";
import NavigationMenuItem from "./NavigationMenuItem";

const useStyle = makeStyles((theme) => ({
  root: {
    background: "#F1F1F1",
    boxShadow: "none",
    borderBottom: "1px solid #cccccc5e",
  },
}));

const NavigationItems = (props) => {
  const isUserLoggedIn = useSelector((state) => state.loginRequest.isLoggedIn);
  const classes = useStyle(props);
  const studentHoldData = useSelector(
    (state) => state.profileData.studentHoldData,
  );
  const [studentholdType, setStudentholdType] = useState([]);

  useEffect(() => {
    if (studentHoldData.length > 0) {
      const sesHoldTypes = studentHoldData.map((item) => item.ses_holdtype);
      const uniqueSesHoldTypes = [...new Set(sesHoldTypes)];
      setStudentholdType(uniqueSesHoldTypes);
    }
  }, [studentHoldData]);

  // Define messages based on hold types
  const messages = {
    284210000:
      "Ton compte est suspendu pour la raison suivante : Suspension (études). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Registrariat : ",
    284210001:
      "Ton compte est suspendu pour la raison suivante : Suspension (finances). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Registrariat : ",
    284210002:
      "Ton compte est suspendu pour la raison suivante : Suspension (administration). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Registrariat : ",
    943240001:
      "Ton compte est suspendu pour la raison suivante : Suspension (orientation). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Bureau international : ",
  };

  const contactEmails = {
    284210000: "mailto:registraire@ustboniface.ca",
    284210001: "mailto:finances@ustboniface.ca",
    284210002: "mailto:registraire@ustboniface.ca",
    943240001: "mailto:international@ustboniface.ca",
  };

  return (
    <AppBar position="static" classes={{ root: classes.root }}>
      {window.localStorage.getItem("isUserLoggedIn") || isUserLoggedIn ? (
        <>
          <Toolbar disableGutters>
            <Grid container item xs={12} sm={11} style={{ margin: "0 auto" }}>
              <NavigationMenuItem />
            </Grid>
          </Toolbar>

          {studentholdType.map((holdType) => (
            <Typography
              key={holdType}
              style={{
                background: "#efd6e1",
                color: "black",
                marginLeft: "4.8rem",
                width: "90%",
                paddingBottom: "1rem",
              }}
            >
              {messages[holdType]}
              <a href={contactEmails[holdType]}>
                {holdType === 943240001
                  ? "international@ustboniface.ca"
                  : holdType === 284210001
                    ? "finances@ustboniface.ca"
                    : "registraire@ustboniface.ca"}
              </a>
              <br />
            </Typography>
          ))}

          <br />
        </>
      ) : (
        <Toolbar disableGutters>
          <Grid container item xs={12} sm={11} style={{ margin: "0 auto" }}>
            <NavigationMenuItem />
          </Grid>
        </Toolbar>
      )}
    </AppBar>
  );
};

export default NavigationItems;
